/** Merge extracted values (strings/numbers) into a string-valued form state by key. */
export function mergeStrings<T extends Record<string, string>>(cur: T, x: Record<string, unknown>): T {
  const next = { ...cur };
  for (const k of Object.keys(cur) as (keyof T)[]) {
    const v = x[k as string];
    if (typeof v === 'string') next[k] = v as T[keyof T];
    else if (typeof v === 'number') next[k] = String(v) as T[keyof T];
  }
  return next;
}

/** Drop empty-string / null / undefined (and empty nested objects) before POSTing. */
export function clean<T extends Record<string, unknown>>(obj: T): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === '' || v == null) continue;
    if (typeof v === 'object' && !Array.isArray(v)) {
      const inner = clean(v as Record<string, unknown>);
      if (Object.keys(inner).length) out[k] = inner;
    } else {
      out[k] = v;
    }
  }
  return out;
}
